import { render, staticRenderFns } from "./game-nature.vue?vue&type=template&id=72d33689&scoped=true&"
import script from "./game-nature.vue?vue&type=script&lang=js&"
export * from "./game-nature.vue?vue&type=script&lang=js&"
import style0 from "./game-nature.vue?vue&type=style&index=0&id=72d33689&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d33689",
  null
  
)

export default component.exports